import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseDeleteMutation, ITrainingPersonRequirement, IGetDeleteRequest } from '../../interfaces'

const getBulkDeleteTrainingPersonRequirementsMutationRequest: IGetDeleteRequest = params => {
  return {
    method: 'delete',
    url: `${config.baseUrl}/PersonTrainingRequirements/person/`,
  }
}

const useBulkDeleteTrainingPersonRequirementsMutation: IUseDeleteMutation<ITrainingPersonRequirement, { requirementIds: number[]; personId: number }> = (params, options = {}) => {
  const request = useMemo(() => getBulkDeleteTrainingPersonRequirementsMutationRequest(params), [params])

  const deleteTraining = useCallback(
    async (data: { requirementIds: number[]; personId: number }) => {
      return axios({
        ...request,
        url: request.url + data.personId,
        data: { requirementIds: data.requirementIds },
      }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ITrainingPersonRequirement, Error, any>({ mutationFn: deleteTraining, ...options })

  return response
}

export default useBulkDeleteTrainingPersonRequirementsMutation
